/**
 *
 */
import {AppConfig} from '../types/AppConfig';


/**
 * @see inc/theme/site-setup.php > Site > theme > jsAppConfig
 *
 * @returns {AppConfig|null}
 */
const getAppConfig = (): AppConfig | null =>
{
	const configElem = document.querySelector( '#app-config' );

	if (configElem instanceof HTMLElement) {
		return JSON.parse( configElem.innerText );
	}

	return null;
};


/**
 *
 */
const getAppConfigVar = ( varName: keyof AppConfig ): any =>
{
	const config = getAppConfig();

	return config ? config[varName] : null;
};


/**
 *
 */
export {getAppConfig, getAppConfigVar};